import { render, staticRenderFns } from "./configuration-file.page.vue?vue&type=template&id=20044489&scoped=true&"
import script from "./configuration-file.page.vue?vue&type=script&lang=js&"
export * from "./configuration-file.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20044489",
  null
  
)

export default component.exports